<template>
	<div class="basic-container">
		<section class="board-detail-area">
			<div class="sub-title">
				<h4 class="board">{{ apiData.contentTitle }}</h4>
			</div>
			<div class="board-header" v-if="viewType === 'consult'">
				<div class="col-header">문의유형</div>
				<div class="col-contents">
					<span v-if="apiData.qnaType === 'PROGRAM'">프로그램</span>
					<span v-else-if="apiData.qnaType === 'FEE'">정산</span>
					<span v-else-if="apiData.qnaType === 'ETC'">기타</span>
				</div>
			</div>
			<div class="board-header" :class="viewType !== 'consult' ? 'end-line' : ''">
				<div class="col-header">등록일</div>
				<div class="col-contents">
					{{ apiData.modDate === null ? $moment(apiData.regDate).format('YY.MM.DD') : $moment(apiData.modDate).format('YY.MM.DD') }}
				</div>
				<div class="col-header">작성자</div>
				<div class="col-contents">{{ apiData.userNmKor }}</div>
			</div>
			<div class="board-header end-line" v-if="viewType === 'consult'">
				<div class="col-header">첨부파일</div>
				<div class="col-contents max col-file">
					<a v-for="item in fileList" v-bind:key="item" :href="CONST.API_SERVER + '/okta/file/' + item.split('|')[0]" :external-url="true">
						<div><img class="icon-file" :src="require('../../assets/images/icon/icon-file@2x.png')" /> {{ item.split('|')[1] }}</div>
						<br
					/></a>
				</div>
			</div>
			<div class="board-contents" style="border-bottom: 1px solid #eeeeee">{{ apiData.contentBody }}</div>
			<!-- 댓글 라인 -->
			<div class="comments-area" v-if="viewType === 'consult'">
				<div class="comments-head" v-for="(row, i) in commentList" :key="'comment_' + i">
					<div class="btn-menu" v-if="row.userSeqNo === loginMember.seqNo">
						<a @click="showModifyComment(row.qnaCmtSeqNo, row.comment)">수정</a> |
						<a @click="doDeleteComment(row.qnaCmtSeqNo)">삭제</a>
					</div>
					<p class="comments-name">{{ row.adminType === null ? row.userNmKor : 'OKTA마케팅지원팀' }}</p>
					<p class="comments-date">
						{{ $moment(row.regDate).format('YY.MM.DD') }}
					</p>
					<!--					<p class="comments-text" v-if="row.qnaCmtSeqNo === updateSeqNo">-->
					<!--						<textarea class="height-5 color-white-bg" v-model="row.comment"></textarea>-->
					<!--						<button class="pinkBtn tiny" @click="doModifyComment(row.qnaCmtSeqNo, row.comment)">수정</button>-->
					<!--					</p>-->
					<p class="comments-text">
						{{ row.comment }}
					</p>
				</div>
				<div class="comments-body">
					<textarea class="height-4 comments-qna qna-textarea" placeholder="내용을 입력해주세요." v-model="comment"></textarea>
					<button @click.prevent.stop="doSubmitComment()" :class="updateSeqNo > 0 ? 'mr-8 width-4' : ''" v-text="updateSeqNo > 0 ? '수정' : '등록'">
						등록
					</button>
					<button class="width-4" @click="cancelComment()" v-if="updateSeqNo > 0">취소</button>
				</div>
			</div>
			<!-- <div class="board-contents" v-html="$options.filters.newLine(apiData.contentBody)">{{ listPage }}</div>
             <div class="board-header">
           <div class="col-header">이전글</div>
           <div class="col-contents max">
             <nav-link :url="'/board/' + viewType + '/' + apiData.prevBoardIdx"> {{ apiData.prevContentTitle }}</nav-link>
           </div>
         </div>
         <div class="board-header end-line">
           <div class="col-header">다음글</div>
           <div class="col-contents max">
             <nav-link :url="'/board/' + viewType + '/' + apiData.nextBoardIdx"> {{ apiData.nextContentTitle }}</nav-link>
           </div>
         </div>-->
		</section>
		<div class="btn-area">
			<button class="greenLineBtn" @click="goList">목록보기</button>
		</div>
	</div>
</template>

<script>
import CONST from '@/constants';

export default {
	title: '게시판 상세',
	name: 'BoardDetail',
	props: ['viewType', 'seqNo'],
	data: function() {
		return {
			CONST,
			select: 1,
			apiData: [],
			commentList: [],
			loginMember: null,
			fileList: null,

			updateSeqNo: 0,
			comment: '',
		};
	},
	watch: {
		// viewType: function() {
		// 	this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, this.viewType === 'consult' ? 'QNA_CONSULT' : 'QNA_RECEIVE');
		// },
	},
	beforeCreate() {},
	created() {},
	mounted() {
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
		// this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, this.viewType === 'consult' ? 'QNA_CONSULT' : 'QNA_RECEIVE');
		this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'COMMUNITY');
		this.getBoardDetail();
	},
	methods: {
		goList: function() {
			this.$device.pushView('/qna/' + this.viewType);
		},
		getBoardDetail: function() {
			let formData = new FormData();
			let apiUrl;
			if (this.viewType === 'consult') {
				formData.append('qnaSeqNo', this.seqNo);
				apiUrl = '/api/board/getConsultDetail.do';
			} else {
				formData.append('seqNo', this.seqNo);
				apiUrl = '/api/board/getInboxDetail.do';
			}

			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + apiUrl, formData)
				.then(res => {
					if (res.data.resultCode !== 0) {
						window.alert(res.data.resultMsg);
						this.goList();
					} else {
						this.apiData = res.data.data;
						if (this.viewType === 'send') this.apiData.userNmKor = this.apiData.sendUserNmKor;
						if (this.viewType === 'receive') this.apiData.userNmKor = this.apiData.receiveUserNmKor;
						if (this.viewType === 'consult') {
							this.commentList = res.data.data.consultCommentList;
							if (this.apiData.consultFile != null && this.apiData.consultFile !== '') {
								this.fileList = this.apiData.consultFile.split(',');
							} else {
								this.fileList = [];
							}
						}
					}
				})
				.catch(e => {
					console.error(e);
					window.alert(e.message);
				});
		},
		doSubmitComment: function() {
			if (this.$device.isEmpty(this.comment)) {
				alert('댓글 내용을 작성하세요.');
				return false;
			}
			if (this.updateSeqNo > 0) {
				if (!confirm('수정하시겠습니까?')) {
					return false;
				}
			}

			let formData = new FormData();
			formData.append('qnaSeqNo', this.seqNo);
			formData.append('qnaCmtSeqNo', this.updateSeqNo);
			formData.append('comment', this.comment);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/board/onlineConsultCommentSubmit.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.updateSeqNo = 0;
						this.comment = '';
						this.getBoardDetail();
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		showModifyComment: function(qnaCmtSeqNo, comment) {
			this.updateSeqNo = qnaCmtSeqNo;
			this.comment = comment;
		},
		cancelComment: function() {
			this.updateSeqNo = 0;
			this.comment = '';
		},
		doDeleteComment: function(qnaCmtSeqNo) {
			if (confirm('삭제하시겠습니까?')) {
				let formData = new FormData();
				formData.append('qnaCmtSeqNo', qnaCmtSeqNo);
				this.$apiClient
					.getInstance()
					.post(this.$apiClient.getApiServer() + '/api/board/onlineConsultCommentDelete.do', formData)
					.then(res => {
						if (res.data.resultCode === 0) {
							this.updateSeqNo = 0;
							this.comment = '';
							this.getBoardDetail();
						} else {
							window.alert(res.data.resultMsg);
						}
					})
					.catch(e => console.error(e));
			}
		},
	},
};
</script>
